import React, { useState, useEffect } from 'react'
import EventsSearch from './EventsSearch'
import { deleteCertificates, getEventData } from '../../functions/certificatesAPI';
import { ChevronLeftIcon, DownloadIcon, ExclamationIcon, PencilIcon, TrashIcon } from '@heroicons/react/outline';
import Wmbutton from '../../ui-components/wm-button/Wm.button';
import Checkbox from '@material-ui/core/Checkbox';
import WmModals from '../../modals/Wm.Modals';
import { useHistory } from 'react-router-dom'
import Spinner from '../../Components/spinner/Spinner';
import usePostData from '../../hooks/usePostData';
import Pagination from "react-js-pagination";


function ViewEvents() {
    const history = useHistory()
    const url = window.location.pathname
    const lastSegment = url.split("/").pop();
    const [eventListData, setEventData] = useState(null)
    const [searchEmail, setSearchEmail] = useState('')
    const [page_no, setPageNo] = useState(0)
    const [isCertLoaded, setIsCertLoaded] = useState(true)
    const [selectedIdForDelete, setSelectedIdForDelete] = useState([])
    useEffect(() => {
        handleFetchEvent()
    }, [lastSegment, searchEmail, page_no])

    const handleFetchEvent = () => {
        setIsCertLoaded(true)
        getEventData({ eventId: lastSegment, email: searchEmail, page_no })
            .then(function (res) {
                setEventData(res.data)
                // setIsCertLoaded(false)
            })
            .catch(function () {
                // setIsCertLoaded(false)
            })
            .finally(() => {
                setIsCertLoaded(false)
            })
    }
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
    const handleDeleteModal = (e) => {
        let $thisButton = e.currentTarget
        if (!selectedIdForDelete.length) {
            let id = $thisButton.getAttribute('data-id')
            setSelectedIdForDelete([+id])
        }
        setIsDeleteModalOpen(true)
    }



    const handleCheckDelete = (e) => {
        if (e.target.checked == true) {
            setSelectedIdForDelete([...selectedIdForDelete, Number(e.target.value)]);
        } else {
            let check_list = [];
            selectedIdForDelete.map(check => {
                if (Number(check) != Number(e.target.value)) {
                    check_list.push(Number(check));
                }
            });
            setSelectedIdForDelete(check_list);
        }
    }

    const handleDeleteCert = () => {
        deleteCertificates(selectedIdForDelete, lastSegment)
            .then((res) => {
                handleFetchEvent()
                setIsDeleteModalOpen(false)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    const { setDataToServer } = usePostData({
        url: '/certificate/downloadAll',
        onSuccess: () => handleFetchEvent()
    })
    const handleCreateZip = () => {
        let data = {
            event_id: lastSegment
        }
        setDataToServer.mutate(data)
    }
    const handlePageClick = (value) => {
        window.scrollTo(0, 0)
        setPageNo(value - 1)
    }
    const [certificateFormData, setCertificateFormData] = useState([])
    const handleGetCertificateDetail = usePostData({
        url: '/Certificate/getCertDetails',
        onSuccess: (data) => {
            setCertificateFormData(data.data)
        }
    })
    const [openEditModal, setOpenEditModal] = useState(false)
    const [certId, setCertId] = useState(null)
    const handleEditModal = (cert_id) => {
        setOpenEditModal(true)
        let data = {
            cert_id
        }
        setCertId(cert_id)
        handleGetCertificateDetail.setDataToServer.mutate(data)
    }
    const handleChangeCertForm = (e) => {
        let $this = e.currentTarget
        let value = $this.value
        let name = $this.name
        let index = $this.getAttribute('data-index')
        let data = certificateFormData[index]
        data[name] = value
        setCertificateFormData([...certificateFormData])
    }

    const [updatedSuccess, setUpdatedSuccess] = useState(false)
    const handleSaveCertificateDetail = usePostData({
        url: '/Certificate/updateCertDetails',
        onSuccess: () => {
            setUpdatedSuccess(true)
            setTimeout(() => {
                setUpdatedSuccess(false)
            }, 1500)
        }
    })
    const handleSaveCertificate = () => {
        let data = {
            cert_id: certId,
            cert_data: certificateFormData
        }
        handleSaveCertificateDetail.setDataToServer.mutate(data)
    }
    return (
        <>
            <div className="">
                <div className="">
                    <div className="flex items-center space-x-5">
                        <div className='w-12 h-12 group bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300 cursor-pointer' onClick={() => history.goBack()}>
                            <ChevronLeftIcon className='w-full p-2 transition ease-in-out duration-500 text-gray-600 group-hover:transform -translate-x-2' />
                        </div>
                        <div className="flex-grow">
                            <EventsSearch placeholder='Search by email id eg:example@mail.com' className="ring-1 ring-gray-400 px-3 py-2" inputClass="w-full pl-2" value={searchEmail} onSearch={(e) => setSearchEmail(e.target.value)} />
                        </div>
                        {/* <div className="">
                            <Wmbutton label={"Add record"} className="w-full rounded-3xl px-4" type="button" color="primary" />
                        </div> */}
                        {/* {eventListData?.zip_status === 0 &&
                            <div className="">
                                <Wmbutton onClick={handleCreateZip} label={"Create ZIP"} className="w-full rounded-3xl px-4" type="button" color="primary" />
                            </div>}
                        {eventListData?.zip_status === 1 &&
                            <div className="">
                                <a href={eventListData?.zip_url} download className="w-full flex rounded-3xl px-4 bg-green-200 text-green-700 py-2 font-semibold">
                                    <DownloadIcon className='w-6 mr-2' />
                                    Download ZIP
                                </a>
                            </div>}
                        {eventListData?.zip_status === 3 &&
                            <div className="">
                                <p className='mb-0 px-4 bg-yellow-200 text-yellow-700 py-2 rounded-3xl'>In Progress</p>
                            </div>
                        } */}
                    </div>
                    {isCertLoaded ? <div className='relative w-full mt-7 flex items-center justify-center'><Spinner className="" width={50} height={50} /></div>
                        : eventListData?.data?.length > 0
                            ? <div>
                                <div className="overflow-x-auto bg-white rounded-lg shadow overflow-y-auto relative w-100 mt-10">
                                    <table className="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative">
                                        <thead>
                                            <tr className="text-left">
                                                <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                                                </th>
                                                <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                                                    Cert.no
                                                </th>
                                                <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs w-80">
                                                    Participants Name/Email
                                                </th>
                                                <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs w-80">
                                                    Searchable Value
                                                </th>
                                                <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                                                    Download PDF
                                                </th>
                                                <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                                                    Status
                                                </th>
                                                <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {eventListData?.data?.map((data, idx) => {
                                                const { status,searchable_value } = data
                                                return <tr key={idx} className="cursor-pointer">
                                                    <td className="border-dashed border-t border-gray-200 userId">
                                                        <Checkbox className={'deleteCheck'} inputProps={{ 'aria-label': 'primary checkbox' }} value={data.id} onChange={(e) => handleCheckDelete(e)} />
                                                    </td>
                                                    <td className="border-dashed border-t border-gray-200 userId">
                                                        <span className="text-gray-700 px-6 py-3 flex items-center text-sm">{data.certificate_number}</span>
                                                    </td>
                                                    <td className="border-dashed border-t border-gray-200 firstName">
                                                        <p className="text-gray-700 mx-6 my-3 flex items-center text-sm  overflow-hidden wordClamp-1" title={data.email}>{data.email}</p>
                                                    </td>
                                                    <td className="border-dashed border-t border-gray-200 firstName">
                                                        <p className="text-gray-700 mx-6 my-3 flex items-center text-sm  overflow-hidden wordClamp-1">{searchable_value}</p>
                                                    </td>
                                                    <td className="border-dashed border-t border-gray-200 lastName">
                                                        <div className='mx-6 my-3'>
                                                            <a href={data.certificate_link} download target="_blank" rel="noopener noreferrer" className=' bg-gray-200 text-gray-700 text-sm rounded px-4 py-2 inline-flex items-center'>
                                                                <DownloadIcon className='w-6 ml-2' />
                                                            </a>
                                                        </div>
                                                    </td>
                                                    <td className="border-dashed border-t border-gray-200 firstName">
                                                        <p className="text-gray-700 mx-6 my-3 flex items-center text-xs  overflow-hidden" title={data.status}>{data.status}</p>
                                                    </td>
                                                    <td className="border-dashed border-t border-gray-200 emailAddress">
                                                        <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                                                            <div className='text-center flex space-x-3'>
                                                                <button data-status={status} className={`px-2 py-1 ${status !== 'Completed' ? ' cursor-not-allowed' : ''}`} disabled={status !== 'Completed' && true} onClick={() => handleEditModal(data.id)}>
                                                                    <PencilIcon className='w-6 text-gray-500' />
                                                                </button>
                                                                <button className='px-2 py-1' data-id={data.id} onClick={handleDeleteModal}>
                                                                    <TrashIcon className='w-6 text-gray-500' />
                                                                </button>
                                                            </div>
                                                        </span>
                                                    </td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <div className='my-10 flex items-center justify-center'>
                                    <Pagination
                                        activePage={page_no + 1}
                                        itemsCountPerPage={10}
                                        totalItemsCount={eventListData?.total_count}
                                        pageRangeDisplayed={3}
                                        onChange={handlePageClick}
                                        hideNavigation={true}
                                        hideDisabled
                                        disabledClass
                                        innerClass={`flex space-x-4 overflow-auto`}
                                        itemClass={`bg-gray-200 rounded-md text-gray-700 cursor-pointer`}
                                        linkClass={`px-5 py-2 inline-block`}
                                        activeClass={`bg-[color:var(--color-5)] text-gray-200`}
                                    />
                                </div>
                            </div>
                            : <div className="col-md-12 mt-3">
                                <span className="block manpro text-xl font-semibold text-center">It seems that your certificates in not processed yet. please wait while the certificates are being generated</span>
                            </div>}
                </div>
            </div>
            <WmModals show={isDeleteModalOpen} onHide={() => setIsDeleteModalOpen(false)} size="md" className="">
                <div className='px-10 py-4'>
                    <div>
                        <p className='text-center text-xl font-semibold text-gray-700 manpro'>Delete Certificate?</p>
                        <p className='text-center mb-0  text-gray-700 manpro'>Are you sure you want to delete?</p>
                        <p className='text-center mb-0 text-gray-700 manpro'>You can't undo this action.</p>
                        <div className=' bg-red-100 rounded border-l-2 border-red-700 my-10'>
                            <div className='flex space-x-3 p-4'>
                                <div>
                                    <ExclamationIcon className='w-6 text-red-600' />
                                </div>
                                <div>
                                    <p className='manpro text-red-800 mb-0 font-semibold'>Warning</p>
                                    <p className='manpro text-red-700 mb-0 text-sm'>By deleting this certifcate all other certificates connected to this will be deleted.</p>
                                </div>
                            </div>
                        </div>
                        <div className='text-center space-x-3'>
                            <button className='px-4 py-1 bg-gray-700 text-white  rounded-full' onClick={() => setIsDeleteModalOpen(false)}>Cancel</button>
                            <button className='px-4 py-1 bg-red-500 rounded-full text-white' onClick={() => handleDeleteCert()}>Delete certificate</button>
                        </div>
                    </div>
                </div>
            </WmModals>
            <WmModals show={openEditModal} onHide={() => setOpenEditModal(false)} size="lg" className="">
                <div className=' py-4'>
                    <div>
                        {handleGetCertificateDetail.isLoading
                            ? <div className='w-10 h-10 mx-auto'><Spinner /></div>
                            : <>
                                <div className='border-b border-gray-300'>
                                    <h3 className='px-6'>Edit Certificate</h3>
                                </div>
                                <div className='px-6 py-4'>
                                    <div className=' grid grid-cols-3 gap-4'>
                                        {certificateFormData.map((certData, idx) => {
                                            const { type, header, text } = certData
                                            return <>
                                                {type === 'TextBox'
                                                    ? <div className="wm_form_group flex flex-col mb-4">
                                                        <label className="wm_form_label font-semibold">{header}</label>
                                                        <input data-index={idx} onChange={handleChangeCertForm} placeholder={header} value={text} type="text" name="text" className="wm_form_input border-bottom border-gray-300" />
                                                    </div>
                                                    : ''}
                                            </>
                                        })}
                                    </div>
                                    {updatedSuccess && <p className='text-center text-green-500'>Certificate Updated Succesfully</p>}
                                    <div className='text-center space-x-3'>
                                        <button disabled={handleSaveCertificateDetail.setDataToServer.isLoading} className='px-4 py-1 bg-red-500 rounded-full text-white' onClick={handleSaveCertificate}>
                                            {handleSaveCertificateDetail.setDataToServer.isLoading
                                                ? 'Updating...'
                                                : 'Save & Update'}
                                        </button>
                                        <button className='px-4 py-1 bg-gray-700 text-white  rounded-full' onClick={() => setOpenEditModal(false)}>Cancel</button>
                                    </div>
                                </div>

                            </>}
                    </div>
                </div>
            </WmModals>
        </>
    )
}

export default ViewEvents
